import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

export const GET_DASHBOARD = 'GET_DASHBOARD'
export const getDashboard = (month, year) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_DASHBOARD)())
    const clientId = getClientId(getState)
    if (month && year && clientId) {
      sendApiRequest(`Dashboards/${clientId}/date/${month}/${year}`, {
        accessToken: getState().auth.account.accessToken
      }).then((response) => {
        if (response.status === 'failure') {
          dispatch(getDashboardError(response))
        }
        if (response.status === 'success') {
          dispatch(getDashboardSuccess(response.data))
        }
      })
    }
  }
}

export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'
export const getDashboardSuccess = createAction(GET_DASHBOARD_SUCCESS)

export const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR'
export const getDashboardError = createAction(GET_DASHBOARD_ERROR)

export const GET_DASHBOARD_AUDITED_ASSETS = 'GET_DASHBOARD_AUDITED_ASSETS'
export const getDashboardAuditedAssets = (month, year) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_DASHBOARD_AUDITED_ASSETS)())
    if (month && year) {
      sendApiRequest(`Dashboards/auditedAssets/${month}/${year}`, {
        accessToken: getState().auth.account.accessToken
      }).then((response) => {
        if (response.status === 'failure') {
          dispatch(getDashboardAuditedAssetsError(response))
        }
        if (response.status === 'success') {
          dispatch(getDashboardAuditedAssetsSuccess(response.data))
        }
      })
    }
  }
}

export const GET_DASHBOARD_AUDITED_ASSETS_SUCCESS = 'GET_DASHBOARD_AUDITED_ASSETS_SUCCESS'
export const getDashboardAuditedAssetsSuccess = createAction(GET_DASHBOARD_AUDITED_ASSETS_SUCCESS)

export const GET_DASHBOARD_AUDITED_ASSETS_ERROR = 'GET_DASHBOARD_AUDITED_ASSETS_ERROR'
export const getDashboardAuditedAssetsError = createAction(GET_DASHBOARD_AUDITED_ASSETS_ERROR)

export const GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH = 'GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH'
export const getDashboardAuditedAssetsByMonth = (month, year) => {
  return (dispatch, getState) => {
    const clientId = getClientId(getState)
    dispatch(createAction(GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH)())
    if (month && year && clientId) {
      sendApiRequest(`Dashboards/auditsByMonth/${clientId}/${month}/${year}`, {
        accessToken: getState().auth.account.accessToken
      }).then((response) => {
        if (response.status === 'failure') {
          dispatch(getDashboardAuditedAssetsByMonthError(response))
        }
        if (response.status === 'success') {
          dispatch(getDashboardAuditedAssetsByMonthSuccess(response.data))
        }
      })
    }
  }
}

export const GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH_SUCCESS =
'GET_DASHBOARD_AUDITED_ASSETS_SUCCESS_BY_MONTH'
export const getDashboardAuditedAssetsByMonthSuccess =
createAction(GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH_SUCCESS)

export const GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH_ERROR =
'GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH_ERROR'
export const getDashboardAuditedAssetsByMonthError =
createAction(GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH_ERROR)

export const GET_DASHBOARD_DAILY_AUDITED_ASSETS = 'GET_DASHBOARD_DAILY_AUDITED_ASSETS'
export const getDashboardDailyAuditedAssets = (month, year, day) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_DASHBOARD_DAILY_AUDITED_ASSETS)())
    const clientId = getClientId(getState)
    sendApiRequest(`NetworkReports/dailyReport/${clientId}/date/${month}/${year}/${day}`, {
      accessToken: getState().auth.account.accessToken
    }).then((response) => {
      if (response.status === 'failure') {
        dispatch(getDashboardDailyAuditedAssetsError(response))
      }
      if (response.status === 'success') {
        dispatch(getDashboardDailyAuditedAssetsSuccess(response.data))
      }
    })
  }
}

export const GET_DASHBOARD_DAILY_AUDITED_ASSETS_SUCCESS =
'GET_DASHBOARD_DAILY_AUDITED_ASSETS_SUCCESS'
export const getDashboardDailyAuditedAssetsSuccess =
createAction(GET_DASHBOARD_DAILY_AUDITED_ASSETS_SUCCESS)

export const GET_DASHBOARD_DAILY_AUDITED_ASSETS_ERROR =
'GET_DASHBOARD_DAILY_AUDITED_ASSETS_ERROR'
export const getDashboardDailyAuditedAssetsError =
createAction(GET_DASHBOARD_DAILY_AUDITED_ASSETS_ERROR)

const initialState = {
  isGettingDashboard: false,
  hasGottenDashboard: false,
  getDashboardError: {},
  dashboard: {},
  isGettingDashboardAuditedAssets: false,
  hasGottenDashboardAuditedAssets: false,
  dashboardAuditedAssets: [],
  getDashboardAuditedAssetsError: {},
  isGettingDashboardAuditedAssetsByMonth: false,
  hasGottenDashboardAuditedAssetsByMonth: false,
  dashboardAuditedAssetsByMonth: {},
  isGettingDashboardDailyAuditedAssets: false,
  hasGottenDashboardDailyAuditedAssets: false,
  dashboardDailyAuditedAssets: {}
}

export default handleActions({

  [GET_DASHBOARD]: (state) => ({
    ...state,
    isGettingDashboard: true,
    hasGottenDashboard: false,
    dashboard: {}
  }),

  [GET_DASHBOARD_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingDashboard: false,
      hasGottenDashboard: true,
      dashboard: payload
    }
  },

  [GET_DASHBOARD_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingDashboard: false,
      hasGottenDashboard: false,
      getDashboardError: payload
    }
  },

  [GET_DASHBOARD_AUDITED_ASSETS]: (state) => ({
    ...state,
    isGettingDashboardAuditedAssets: true,
    hasGottenDashboardAuditedAssets: false,
    dashboardAuditedAssets: []
  }),

  [GET_DASHBOARD_AUDITED_ASSETS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingDashboardAuditedAssets: false,
      hasGottenDashboardAuditedAssets: true,
      dashboardAuditedAssets: payload
    }
  },

  [GET_DASHBOARD_AUDITED_ASSETS_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingDashboardAuditedAssets: false,
      hasGottenDashboardAuditedAssets: false,
      getDashboardAuditedAssetsError: payload
    }
  },

  [GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH]: (state) => ({
    ...state,
    isGettingDashboardAuditedAssetsByMonth: true,
    hasGottenDashboardAuditedAssetsByMonth: false,
    dashboardAuditedAssetsByMonth: {}
  }),

  [GET_DASHBOARD_AUDITED_ASSETS_BY_MONTH_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingDashboardAuditedAssetsByMonth: false,
      hasGottenDashboardAuditedAssetsByMonth: true,
      dashboardAuditedAssetsByMonth: payload
    }
  },

  [GET_DASHBOARD_DAILY_AUDITED_ASSETS]: (state) => ({
    ...state,
    isGettingDashboardDailyAuditedAssets: true,
    hasGottenDashboardDailyAuditedAssets: false,
    dashboardDailyAuditedAssets: {}
  }),

  [GET_DASHBOARD_DAILY_AUDITED_ASSETS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingDashboardDailyAuditedAssets: false,
      hasGottenDashboardDailyAuditedAssets: true,
      dashboardDailyAuditedAssets: payload
    }
  },

}, initialState)
